import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {withStyles} from '@material-ui/core/styles';
import BTN from "../Button/Button";

const menuItems = (props) => {

    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #c2c2c3',
            width:'180px'
        },
    })((props) => (
        <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            {...props}
        />
    ));
    const StyledMenuItem = withStyles((theme) => ({
        root: {
            '&:hover': {
                backgroundColor: '#c2c2c3',
            },
        },
    }))(MenuItem);
    return (
        <>
                    <BTN
                        label="DOWNLOAD DOCUMENT(S)"
                        ariaControls="download-document"
                        ariaHaspopup="true"
                        variant="success"
                        isVisible={true}
                        isDisabled={props.isDisabledButton}
                        size="sm"
                        actionHandler={props.handleClick}
                        style={{width: "auto"}}
                    />

                    <StyledMenu
                        id="download-document"
                        anchorEl={props.anchorEl}
                        keepMounted
                        open={Boolean(props.anchorEl)}
                        onClose={props.handleClose}
                    >
                        {props.menuItems.map((item, index) =>
                            <StyledMenuItem key={index} onClick={item.onClick}>{item.label}</StyledMenuItem>
                        )}
                    </StyledMenu>
        </>
    )

}

export default menuItems;
